// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const ADD_MEASUREMENT_LOADING = 'ADD_MEASUREMENT_LOADING';
export const ADD_MEASUREMENT_SUCCESS = 'ADD_MEASUREMENT_SUCCESS';
export const ADD_MEASUREMENT_ERROR = 'ADD_MEASUREMENT_ERROR';
export const UPDATE_MEASUREMENT_LOADING = 'UPDATE_MEASUREMENT_LOADING';
export const UPDATE_MEASUREMENT_SUCCESS = 'UPDATE_MEASUREMENT_SUCCESS';
export const UPDATE_MEASUREMENT_ERROR = 'UPDATE_MEASUREMENT_ERROR';
export const DELETE_MEASUREMENT_LOADING = 'DELETE_MEASUREMENT_LOADING';
export const DELETE_MEASUREMENT_SUCCESS = 'DELETE_MEASUREMENT_SUCCESS';
export const DELETE_MEASUREMENT_ERROR = 'DELETE_MEASUREMENT_ERROR';

function addMeasurement(patientId: string, measurement: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/growthChart/add${type}Measurement`,
      {
        ...measurement,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_MEASUREMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_MEASUREMENT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_MEASUREMENT_LOADING,
    });
  });
}

function updateMeasurement(patientId: string, measurement: Object, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/growthChart/update${type}Measurement`,
      {
        ...measurement,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_MEASUREMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_MEASUREMENT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_MEASUREMENT_LOADING,
    });
  });
}

function deleteMeasurement(patientId: string, measurementId: string, type: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/growthChart/delete${type}Measurement`,
      {
        measurementId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_MEASUREMENT_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_MEASUREMENT_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_MEASUREMENT_LOADING,
    });
  });
}

export function addInfantMeasurement(patientId: string, test: Object) {
  return addMeasurement(patientId, test, 'Infant');
}
export function updateInfantMeasurement(patientId: string, test: Object) {
  return updateMeasurement(patientId, test, 'Infant');
}
export function deleteInfantMeasurement(patientId: string, testId: string) {
  return deleteMeasurement(patientId, testId, 'Infant');
}
export function addChildMeasurement(patientId: string, test: Object) {
  return addMeasurement(patientId, test, 'Child');
}
export function updateChildMeasurement(patientId: string, test: Object) {
  return updateMeasurement(patientId, test, 'Child');
}
export function deleteChildMeasurement(patientId: string, testId: string) {
  return deleteMeasurement(patientId, testId, 'Child');
}
export function updateRequiredMeasurement(patientId: string, test: Object) {
  return updateMeasurement(patientId, test, 'Required');
}



// WEBPACK FOOTER //
// ./client/src/actions/growthChartActions.js